import React, { Component } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import { observer, inject } from "mobx-react";


class InlineRating extends Component {
  constructor(props) {
    super(props);
    this.state={
      detail:{
        my_mark:this.props.rating_user_mark,
        mark:this.props.rating_mark
      }
    };
  }
  canIVote() {
    return true;
    if(this.props.me && this.props.me.id && this.props.me.id==this.props.user_id) {
      return false;
    }
    if(typeof this.state.detail.my_mark!=='undefined') {
      const mark=parseInt(this.state.detail.my_mark);
      if(isNaN(mark) || mark===0) {
        return true;
      }
    }
    return false;
  }
  pushMark(mark) {
    if(this.canIVote()) {
      console.log('props',this.props);
      axios.post('/sysapi/rating2/rate',{
        category_id:this.props.category,
        element_id:this.props.element,
        module_id:this.props.module_id,
        module_code:this.props.module_code,
        mark: mark,
      }).then((item)=>{
        if(item.data.answer) {
          this.props.linker.value.rating_summary = item.data.answer.summary;
          this.props.linker.value.rating_voters = item.data.answer.voters;
          this.props.linker.value.rating_your_mark = item.data.answer.your_mark;
          this.props.linker.value.rating_can_rate=false;
        }
      })
      /*axios.post(`/api/rating2/${this.props.category}/${this.props.element}`, {mark: mark}).then((item)=> {
        this.setState({detail: item.data.answer});
      });*/
    }
  }
  getValue() {
    const val=parseInt(this.props.linker.value.rating_summary || 0);
    if(val>0) {
      return `+${val}`;
    }
    if(val<0) {
      return `${val}`;
    }
    return val;
  }
  getVoters() {
    return parseInt(this.props.linker.value.rating_voters || 0);
  }
  getMark() {
    return parseInt(this.props.linker.value.rating_summary || 0);
  }
  getValueClass() {
    const val=this.getMark();
    if(val>0) {
      return 'const1';
    }
    if(val<0) {
      return 'const2';
    }
    return '';
  }
  getPlusClass() {
    if(!this.canIVote()) {
      const mark=this.getMark();
      if(mark<0) {
        return 'op50';
      }
    } else {
      return 'op50';
    }
  }
  getMinusClass() {
    if(!this.canIVote()) {
      const mark=this.getMark();
      if(mark>0) {
        return 'op50';
      }
    } else {
      return 'op50';
    }
  }
  render() {
    return (
      <span>
        <span className={`pright10 }`}>
          <span className={`bold ${this.getValueClass()}`}>{this.getValue()}</span> <span className="fs11 w4">({this.getVoters()})</span>
        </span>
        {this.props.linker.value.rating_can_rate?(
          <>
            <span className={`const1 mright10 ${this.getPlusClass()} pointer`} onClick={()=>{ this.pushMark(1); }}>
              <i className="mdi fs20 mdi-thumb-up-outline"></i>
            </span>
            <span className={`const2 mright10 ${this.getMinusClass()} pointer`} onClick={()=>{ this.pushMark(-1); }}>
              <i className="mdi fs20 mdi-thumb-down-outline"></i>
            </span>
          </>
        ):null}
      </span>
    )
  }
}

function mapStateToProps(state) {
  return {
    me:state.me,
  }
}


export default inject("meStore")(observer(InlineRating));